import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';

import { Style } from '../../../../Common/Styles/models/style.model';
import { DropdownOptionModel } from '../../../../Common/Forms/models/dropdown-option.model';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { StylesService } from '../../../../Common/Styles/services/styles.service';
import { MonitoringTextStyleModel } from '../../../Shared/models/monitoring-text-style.model';
import { BriefingStyleStateEnum } from '../../../../Common/MonitorShared/enum/briefing-style-state.enum';
import { messageSeverityEnum } from '../../../../Common/Misc/enums/message-severity.enum';
import { CheckboxTypesEnum } from '../../../../Common/Forms/enums/checkbox-types.enum';
import { RadioTypesEnum } from '../../../../Common/Forms/enums/radio-types.enum';
import { SaveTwigTemplateDialogComponent } from '../../../../Common/Dialogs/components/SaveTwigTemplateDialog/save-twig-template-dialog.component';
import { styleTypeApiEnumToBriefingBlockTypeEnum } from '../../../Briefings/enums/briefing-block-type.enum';
import { Template } from '../../../../Common/Styles/models/template.model';
import { ButtonTypesEnum } from '../../../../Common/Forms/enums/button-types.enum';
import { FontAlignmentEnum } from '../../../../Common/Forms/enums/font-alignment.enum';
import { AbstractPageBuilderService } from '../../../../Common/PageBuilder/services/abstract-page-builder.service';
import { TextStyleFieldComponent } from '../../../../Common/PageBuilder/components/TextStyleField/text-style-field.component';

@Component({
    selector: 'agpr-briefing-text-style-field',
    templateUrl: '../../../../Common/PageBuilder/components/TextStyleField/text-style-field.component.html',
    styleUrls: ['../../../../Common/PageBuilder/components/TextStyleField/text-style-field.component.scss'],
    standalone: false
})
export class BriefingTextStyleFieldComponent extends TextStyleFieldComponent implements OnInit, OnDestroy, OnChanges {
    @Input() declare value: MonitoringTextStyleModel;
    @Input() hidePadding: boolean = false;

    @Output() changes: EventEmitter<MonitoringTextStyleModel> = new EventEmitter<MonitoringTextStyleModel>();

    readonly fontAlignmentEnum = FontAlignmentEnum;
    readonly checkboxTypesEnum = CheckboxTypesEnum;
    readonly radioTypesEnum = RadioTypesEnum;
    readonly messageSeverityEnum = messageSeverityEnum;
    readonly buttonTypes = ButtonTypesEnum;

    protected defaultStyleStateOptions: DropdownOptionModel[] = [
        { label: 'Briefings.formField.styles.defaultAgilityStyleOne', value: BriefingStyleStateEnum.BRIEFING_1 },
        { label: 'Briefings.formField.styles.defaultAgilityStyleTwo', value: BriefingStyleStateEnum.BRIEFING_2 },
        { label: 'Briefings.formField.styles.defaultAgilityStyleThree', value: BriefingStyleStateEnum.BRIEFING_3 },
        { label: 'Briefings.formField.styles.defaultAgilityCanvasOne', value: BriefingStyleStateEnum.CANVAS_1 },
        { label: 'Briefings.formField.styles.custom', value: BriefingStyleStateEnum.CUSTOM }
    ];

    constructor(
        protected coreDialogService: CoreDialogService,
        protected stylesService: StylesService,
        // This is actually briefingService, but injecting briefing service causes a circular dependency
        protected briefingsService: AbstractPageBuilderService
    ) {
        super(coreDialogService, stylesService, briefingsService);
    }

    /**
     * Opens the save-twig-template-dialog after loading the data needed for it
     */
    public saveExpertTemplate(): void {
        if (!this.styleModel) {
            this.styleModel = new Style();
        }

        this.styleModel.style = this.value;
        this.styleModel.template = this.value.template;
        this.saveTwigTemplateDialogModel.inputs.defaultTemplate = this.briefingsService.getDefaultTemplateByBlockType(
            styleTypeApiEnumToBriefingBlockTypeEnum.get(this.field.styleType),
            BriefingStyleStateEnum.BRIEFING_1
        );
        // Set the default template if there's not a template on this style already
        if (!this.styleModel.template) {
            this.setTemplate = true;
            this.styleModel.template = new Template();
            this.styleModel.template.template = this.saveTwigTemplateDialogModel.inputs.defaultTemplate;
        }

        this.saveTwigTemplateDialogModel.inputs.type = this.field.styleType;
        this.saveTwigTemplateDialogModel.inputs.inputStyle = this.styleModel;
        const dialogKey = this.coreDialogService.open(SaveTwigTemplateDialogComponent, this.saveTwigTemplateDialogModel);
    }

    protected updateStyleFromSavedStyle() {
        if (!this.value || !this.styles || !Number(this.value.styleState)) {
            return;
        }

        const savedStyle: Style = this.styles.find(x => x.id === this.value.styleState as number);
        if (!savedStyle) {
            // the list doesn't contain the id we're looking for, can't load it
            return;
        }
        const textStyleModel = new MonitoringTextStyleModel(savedStyle.style);
        textStyleModel.styleState = this.value.styleState;
        textStyleModel.displayStyleState = this.value.displayStyleState;
        textStyleModel.template = savedStyle.template;

        this.value = textStyleModel;
    }
}
